import { Icon } from '../Icon';
import type { IconProps } from '../types';

export function AlertFilledIcon(props: IconProps) {
  return (
    <Icon {...props}>
      <path
        fillRule="evenodd"
        d="M12 1.001c1.135 0 2.094.47 3.057 1.205.94.717 1.994 1.775 3.307 3.088l.343.342c1.313 1.313 2.371 2.368 3.088 3.307C22.529 9.906 23 10.865 23 12s-.47 2.094-1.205 3.057c-.717.94-1.775 1.994-3.088 3.307l-.343.343c-1.313 1.313-2.368 2.371-3.307 3.088C14.094 22.529 13.135 23 12 23s-2.093-.47-3.056-1.205c-.94-.717-1.995-1.775-3.308-3.088l-.342-.343c-1.313-1.313-2.371-2.368-3.088-3.307-.734-.963-1.205-1.922-1.205-3.057s.47-2.093 1.205-3.056c.717-.94 1.775-1.995 3.088-3.308l.342-.342c1.313-1.313 2.368-2.371 3.307-3.088.963-.734 1.922-1.205 3.057-1.205M12 15a1.125 1.125 0 1 0 0 2.25A1.125 1.125 0 0 0 12 15m0-8a1 1 0 0 0-1 1v4a1 1 0 1 0 2 0V8a1 1 0 0 0-1-1"
        clipRule="evenodd"
      />
    </Icon>
  );
}

AlertFilledIcon.displayName = 'AlertFilledIcon';
